import { Category, CategoryFilters } from "@/types/category.ts";
import { Store } from "vuex";
import { RootState } from "@/store/types.ts";
import { CardAttributeConfig } from "@/v2/layouts/category/types.ts";

export function categoryToAttributeConfig(
  category: Category,
  store: Store<RootState>
): CardAttributeConfig[] {
  const { attributesCategories, filterCategories } = category;

  return Object.keys(attributesCategories).map(
    (key: string): CardAttributeConfig => ({
      type: key as keyof CategoryFilters,
      name: (category[`${key}AlternativeName` as keyof Category] ??
        "Name") as string,
      show: attributesCategories[key as keyof CategoryFilters] ?? false,
      filter: filterCategories[key as keyof CategoryFilters],
      initialValue: store.getters["filterBar/getFilterValue"](key),
    })
  );
}
